import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';

@Component({
  selector: 'app-event-page-block-campaign',
  templateUrl: './event-page-block-campaign.component.html',
  styleUrls: ['./event-page-block-campaign.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventPageBlockCampaignComponent implements OnInit {

  @Input() eventPageConfig = null;
  @Input() block = null;
  @Input() index = null;

  public id = '';
  public display = false;
  public image = '';
  public title = '';
  public url = '';
  public buttonText = '';
  public buttonClass = {
    'donation-btn': true,
    'peer-to-peer-btn': false
  }
  public descClasses = 'desc';

  public showLeaderboardBtn = false;
  public leaderboardUrl = '';

  constructor() { }

  ngOnInit(): void {
    const {campaignData, campaignData: {intid}} = this.block
    const handle = this.eventPageConfig.orgInfo?.handle;

    this.id = `campaign-${this.index}`;
    this.display = !this.block.isArchivedOrDeactivated() && !this.block.isCampaignExpaired();
    this.image = campaignData.imageUrl || '/images/org_logo_default_v2.svg';
    this.title = this.block.blockTitle || campaignData.name;
    this.url = `/@${handle}@${intid}`;
    this.buttonText = this.getButtonName(campaignData);
  
    const PEER_TO_PEER = 8;
    if(campaignData.type === PEER_TO_PEER) {
      this.buttonText = 'Become A Champion'
      this.buttonClass = {
        'donation-btn': false,
        'peer-to-peer-btn': true
      }
      this.showLeaderboardBtn = true;
      this.leaderboardUrl = `${window.location.protocol}//${window.location.hostname}/handle/${handle}/campaign/${intid}/leaderboard`;
    }
  }

  getButtonName (campaignData) {
    const { donationButtonLabel, type, qualifiedTaxDeductible } = campaignData;
    if(donationButtonLabel) {
      return donationButtonLabel;
    }
    
    switch (type) {
      case CAMPAIGN_TYPE.TICKETING:
      case CAMPAIGN_TYPE.MERCHANDISE:
      case CAMPAIGN_TYPE.PARTY_SIGNUP:
        return 'Purchase';
      case CAMPAIGN_TYPE.DONATE:
      case CAMPAIGN_TYPE.LONG_PLEDGE:
        return qualifiedTaxDeductible ? 'Donate' : 'Pay';
      default:
        return 'Donate';
    }
  }

}
